import { actionFactory, typeFactory } from 'common/store/scope';

import * as criteriaActions from './criteria/actions';

export const CLEAR = 'CLEAR';
export const ADD_CRITERIA = 'ADD_CRITERIA';
export const REMOVE_CRITERIA = 'REMOVE_CRITERIA';
export const APPLY_CRITERIA = 'APPLY_CRITERIA';
export const TOGGLE_EXPAND = 'TOGGLE_EXPAND';
export const LOAD_CRITERIA = 'LOAD_CRITERIA';

export const {
  ADD_CONSTRAINT,
  REMOVE_CONSTRAINT,
  CLEAR_CONSTRAINTS,
  SET_OPERATOR,
  SET_VALUE,
} = criteriaActions;

export const clear = () => ({
  type: CLEAR,
});

export const addCriteria = criteria => ({
  type: ADD_CRITERIA,
  criteria,
});

export const removeCriteria = criteria => ({
  type: REMOVE_CRITERIA,
  criteria,
});

export const applyCriteria = criteria => ({
  type: APPLY_CRITERIA,
  criteria,
});

export const loadCriteria = criteria => ({
  type: LOAD_CRITERIA,
  criteria,
});

export const toggleExpand = () => ({
  type: TOGGLE_EXPAND,
});

export const addConstraint = (criteria, ...args) => ({
  ...criteriaActions.addConstraint(...args),
  criteria,
});

export const removeConstraint = (criteria, ...args) => ({
  ...criteriaActions.removeConstraint(...args),
  criteria,
});

export const clearConstraints = criteria => ({
  ...criteriaActions.clear(),
  criteria,
});

export const setOperator = (criteria, ...args) => ({
  ...criteriaActions.setOperator(...args),
  criteria,
});

export const setValue = (criteria, ...args) => ({
  ...criteriaActions.setValue(...args),
  criteria,
});

export const factory = namespace => ({
  ...actionFactory(namespace, {
    clear,
    addCriteria,
    removeCriteria,
    applyCriteria,
    loadCriteria,
    toggleExpand,
    addConstraint,
    removeConstraint,
    clearConstraints,
    setOperator,
    setValue,
  }),
  TYPES: typeFactory(namespace, {
    CLEAR,
    ADD_CRITERIA,
    REMOVE_CRITERIA,
    LOAD_CRITERIA,
    APPLY_CRITERIA,
    TOGGLE_EXPAND,
  }),
});

export default factory;
